import { MTGOV } from "./mt-template.js"

window.setTimeout(MTGOV.tryFastLoad, 10);

const mobileLimit = 768;
const sideBarSelector = "#sideNav";

function handleResize() {
    MTGOV.windowResize(mobileLimit);
}

window.addEventListener("resize", handleResize);

window.addEventListener("load", function () {
    MTGOV.onLoad();
    handleResize();
    document.querySelector("#navButton").addEventListener('click', () => {
        const navList = document.querySelector(sideBarSelector);
        if(navList.classList.contains('show')) {
            navList.classList.remove('show');
        } else {
            navList.classList.add('show');
        }
    });
});
